const getters = {
  collectionProducts(state){
    return state.collectionProducts;
  },
  selectedProduct(state){
    return state.selectedProduct;
  },
  mainProducts(state) {
    return state.mainProducts;
  },
  addonProducts(state) {
    return state.addonProducts;
  },
  cardProducts(state) {
    return state.cardProducts;
  },
  selectedBox(state) {
    return state.selectedBox;
  },
  defaultProducts(state) {
    return state.defaultProducts;
  },
  isLoading(state){
    return state.isLoading;
  },
  mainCollection(state){
    return state.mainCollection;
  },
  categoriesList(state){
    return state.categoriesList;
  },
  selectedAddonProducts(state){
    return state.selectedAddonProducts;
  },
  currentCapacity(state){
    return state.selectedAddonProducts
      .map(x => x.capacity ? (x.capacity * x.quantity ) : 0)
      .reduce((prev, next) => prev + next, 0);
  },
  maxCapacity(state){
      let capacityList = state.mainProducts.map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1));
      let maxCapacity = Math.max(...capacityList);
      return maxCapacity;
  },
  feeProduct(state){
    return state.feeProduct;
  },
  occasions(state){
    return state.occasions;
  },
  selectedOccasion(state){
    return state.selectedOccasion;
  },
  selectedOccasionMobile(state){
    return state.selectedOccasionMobile;
  },
  selectedSort(state){
    return state.selectedSort;
  },
  selectedSortMobile(state){
    return state.selectedSortMobile;
  },
  rangePrice(state){
    return state.rangePrice;
  },
  rangePriceMobile(state){
    return state.rangePriceMobile;
  },
};

export default getters;
